import React, { ReactNode } from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";
interface UICardProps {
  children: ReactNode;
  style?:string;
}

const UICard: React.FC<UICardProps> = ({ children, style }) => {
  return <div className={classNames(styles.card, style)}>{children}</div>;
};

export default UICard;
